import { initializeApp, type FirebaseApp, type FirebaseOptions } from 'firebase/app'

const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  ...(import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
    ? { measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID }
    : {}),
}

let firebaseApp: FirebaseApp | undefined

function assertFirebaseConfig(config: FirebaseOptions): void {
  const missing = Object.entries(config)
    .filter(([, value]) => !value)
    .map(([key]) => key)

  if (missing.length > 0) {
    throw new Error(`Firebase configuration is incomplete. Missing: ${missing.join(', ')}`)
  }
}

export function getFirebaseApp(): FirebaseApp {
  if (!firebaseApp) {
    assertFirebaseConfig(firebaseConfig)
    firebaseApp = initializeApp(firebaseConfig)
  }

  return firebaseApp
}

export { firebaseConfig }
